export const COOKIE_SAME_SITE_LAX = 'sameSite=lax'
